import {Component, OnInit, ViewChild} from '@angular/core';
import {NavigationEnd, Router} from '@angular/router';
import * as firebase from 'firebase';
import {LoginService} from '../app/services/login.service';
const firebaseConfig = {
  apiKey: 'AIzaSyB_7CF-G11Rw8qvFI9iqjVsGaFtaeI5WjI',
  authDomain: 'chat-5940f.firebaseapp.com',
  databaseURL: 'https://chat-5940f.firebaseio.com',
  projectId: 'chat-5940f',
  storageBucket: 'chat-5940f.appspot.com',
  messagingSenderId: '537957070666',
  appId: '1:537957070666:web:13312305d5007ed2'
};
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  title = 'app';
  mostrarScript: boolean;
  loadAPI: Promise<any>;
  constructor(private router: Router, public _login: LoginService) {
    firebase.initializeApp(firebaseConfig);
  }

  ngOnInit() {
    this.detectarPlatform();
    this.router.events.subscribe((evt) => {
      if (!(evt instanceof NavigationEnd)) {
        return;
      }
    window.scrollTo(0, 0);
    });
  }
  detectarPlatform() {
    let device = navigator.userAgent;

    if (device.match(/Iphone/i) || device.match(/Ipod/i) || device.match(/Android/i) || device.match(/J2ME/i) ||
     device.match(/BlackBerry/i) || device.match(/iPhone|iPad|iPod/i) || device.match(/Opera Mini/i) || device.match(/IEMobile/i) ||
      device.match(/Mobile/i) || device.match(/Windows Phone/i) || device.match(/windows mobile/i) || device.match(/windows ce/i) ||
       device.match(/webOS/i) || device.match(/palm/i) || device.match(/bada/i) || device.match(/series60/i) || device.match(/nokia/i) ||
        device.match(/symbian/i) || device.match(/HTC/i) || device.match(/CriOS/i)) {
    window.location.href = 'https://portalconsumidorapp.ainia.es/';
    } 
  }


}



// WEBPACK FOOTER //
// ./src/app/app.component.ts